import SimpleControl, {
  SimpleControlKind,
} from 'pages/revisions-module/template-editor/editors/template/toolbar/controls/SimpleControl';
import { useRichTextEditorContext } from '@mantine/tiptap';
import { IconArrowBigDownLine } from '@tabler/icons-react';

/**
 * Used to insert a block aligned to the bottom into the editor.
 */
export default function InsertAlignBottom({ kind }: { kind: SimpleControlKind }) {
  const { editor } = useRichTextEditorContext();

  return (
    <SimpleControl
      kind={kind}
      icon={<IconArrowBigDownLine />}
      label="Odsunúť na spodok strany"
      onClick={() => editor?.chain().focus().setAlignBottom().run()}
    />
  );
}
